<style lang="scss" scoped>
.schools {
	& ::v-deep .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
		}
		&__buttons {
			margin-left: auto;
			font-size: 14px;
			> span {
				margin-right: 10px;
			}
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	&__table {
		color: #27325E;
		td,
		th {
			padding: 15px 0 15px 10px !important;
			&:first-child {
				padding-left: 40px !important;
			}
			&:last-child {
				padding-right: 40px;
			}
			
		}
		tbody tr{
			cursor: pointer;
		}
		&__missing-item {
			display: inline-block;
			padding-left: 10px;
			color: red;
			font-size: 16px;
			vertical-align: middle;
		}
		th {
			background-color:#27325E;
			color:#FFFFFF;
		}
		&__sortable {
			cursor: pointer;
		}
		&__green {
			color: #10B981;
		}
		&__red {
			color: #f56c6c;
		}
		a {
			text-decoration: underline;
			text-underline-offset: 4px;
			text-decoration-thickness: 1px;
		}
	}
	&__search-row {
		display:flex;
		padding:30px;
		justify-content: space-between;
		max-width:800px;
		margin:auto;
	}
	&__search-box {
		border-radius:6px;
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
	}
	&__summary-row {
		display:flex;
		padding:30px;
		justify-content: space-between;
		max-width:800px;
		margin:auto;
	}
	&__summary-box {
		color:#27325E;
		padding:20px 40px;
		border-radius:6px;
		text-align:center;
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
	}
	&__stat-val {
		font-size:40px;
		color:#4368FA;
		font-weight:400;
		display: block;
	}
	&__header {
		@include flex-center;
		&__buttons {
			margin-left: auto;
			font-size: 14px;
			> div {
				margin-left: 15px;
			}
		}
	}

}

</style>
<template lang="pug">
div
	.schools()
		org-app-header
			.schools__header(slot="header")
				h1 Schools
				.schools__header__buttons
					auto-enable-button(:isSyncEnabled="true", :isOrganisation="true")
		.schools__container
			.schools__panel
				loading(v-if="$apollo.loading || loading")
				template(v-else)
					div.schools__summary-row
						div.schools__summary-box
							span.schools__stat-val {{ schoolSyncing }}
							span Schools syncing
						div.schools__summary-box
							span.schools__stat-val(v-if="latestUploadAt !== null") {{ latestUploadAt | format_date_time("DD/MM/Y") }}
							span Latest Sync to {{ providerFullName }} 
						div.schools__summary-box
							span.schools__stat-val Daily
							span Sync
					div.schools__search-row
						result-filter(v-model='filters', class='schools__search-box', :filter-fields="fields", :remember="false", :showReconnect="false")
					table.table.schools__table
						thead
							tr
								th.schools__table__sortable(@click='headerClicked("name")') School Name
									span.el-icon-d-caret.el-icon--right
								th Postcode
								th.schools__table__sortable(@click='headerClicked("has_connection")') Edusync {{ providerName }} Approved
									span.el-icon-d-caret.el-icon--right
								th.schools__table__sortable(@click='headerClicked("installed")') Edusync {{ providerName }} Installed
									span.el-icon-d-caret.el-icon--right
								th.schools__table__sortable(@click='headerClicked("last_provider_sync")') Last Edusync {{ providerName }}
									span.el-icon-d-caret.el-icon--right
								th School Settings
						tbody
							tr(v-for='(row, index) in paginated', @click='rowClicked(row)', :key='index')
								td {{ row.name }}
								td {{ row.address_postcode }}
								td
									span.schools__table__green(v-if="row.has_connection") Approved
									span.schools__table__red(v-else) Not approved
								td
									span.schools__table__green(v-if="row.installed") Yes
									span.schools__table__red(v-else) No
								td
									span(v-if="row.last_provider_sync !== null") {{row.last_provider_sync | format_date_time("DD/MM/Y") }} <br> {{ row.last_provider_sync | format_date_time("hh:mma") }}
								td
									el-button(size="small" @click.stop='rowClicked(row, true)',  style="margin-right:15px").ml-auto Settings
					.schools__footer
						.schools__footer__left
							el-pagination(background="", layout="prev, pager, next", :current-page.sync="page", :page-size="per_page", :total="filtered.length")
						.schools__footer__right 
							| Showing
							strong &nbsp;{{ paginated.length }}
							| &nbsp;out of a possible
							strong &nbsp;{{ filtered.length }}
							| &nbsp;results
	<router-view></router-view>
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import { onLogin } from "../../../vue-apollo";
import provider from '../../../libs/provider';
import moment from "moment-timezone";
import AutoEnableButton from "./../../includes/AutoEnableButton";
import Bugsnag from "@bugsnag/js";
export default {
	components: {
		AutoEnableButton
	},

	data() {
		return {
			page: 1,
			per_page: 50,
			filters: null,
			fields: [
				{
					name: "Name",
					path: "name",
					type: "text",
				},
				{
					name: "Postcode",
					path: "address_postcode",
					type: "text",
				}
			],
			orgSchools: [],
			hasError: false,
			loading: true,
			work: null,
			term: null,
			sortDesc: true
		};
	},

	computed: {
		filtered() {
			let filtered = this.orgSchools;
			if (this.orgSchools && this.filters) {
				if (this.filters.name) {
					filtered = _.filter(filtered, (row) => _.startsWith(row.name.toLowerCase(), this.filters.name.toLowerCase()));
				}
				if (this.filters.address_postcode) {
					filtered = _.filter(filtered, (row) => {
						return this.filters.address_postcode.toLowerCase() === row.address_postcode.toLowerCase();
					});
				}
			}

			return filtered;
		},

		paginated() {
			const page = _.chunk(this.filtered, this.per_page)[this.page - 1];
			return page ? page : [];
		},

		schoolSyncing() {
			return _.filter(this.orgSchools, (school) => {
				return school.Organisation.sync_enabled;
			}).length;
		},

		latestUploadAt() {
			const syncingSchools = _.filter(this.orgSchools, (school) => {
				return school.Organisation.sync_enabled;
			})
			
			return syncingSchools.length ? _.first(syncingSchools).last_provider_sync : null;
		}
	},

	methods: {
		async rowClicked(row, goToSettings = false) {
			if (!await this.isSchoolApproved(parseFloat(row.id))) {
				this.$message.error("The school is not connected to Edusync " + provider.get().providerName);
				return;
			}

			this.$apollo
			.mutate({
				mutation: gql`
					mutation SwitchSchool($schoolId: Float!) {
						SwitchSchool(school_id: $schoolId)
					}
				`,
				variables: {
					schoolId: parseFloat(row.id)
				},
				update: (store, data) => {
					onLogin(this.$apollo.vm.$apolloProvider.clients.defaultClient, data.data.SwitchSchool);
					!goToSettings ? this.$router.push({ name: "directory" }) : this.$router.push({ name:"settings" });
				}
			})
			.catch(e => {
				console.log(e);
				Bugsnag.notify(e);
			});
		},
		async headerClicked(headerToSort) {
			this.sortDesc = !this.sortDesc;
			this.filtered.sort((a, b) => {
				if (this.sortDesc) return a[headerToSort] > b[headerToSort] ? 1 : -1;
				return a[headerToSort] < b[headerToSort] ? 1 : -1;
			});
		},

		async isSchoolApproved(schoolId) {
			const data = await this.$apollo.query({
				query: gql`
					query HasSchoolConnection($schoolId: Float!) {
						HasSchoolConnection(school_id: $schoolId)
					}
				`,
				variables: {
					schoolId
				},
				fetchPolicy: "network-only"
			});
			
			return data.data.HasSchoolConnection || false;
		},

		convertToLocalTime(dateTime) {
			return dateTime !== null ? moment.utc(dateTime).tz(moment.tz.guess()) : null;
		},

		upload() {
			this.$router.push({ name: "organisation.sync" });
		}
	},

	apollo: {
		// SP Provider Data
		orgSchools: {
			query: gql`
				query SchoolsForOrganisation {
					SchoolsForOrganisation {
						name
						address_postcode
						urn
						id
						has_connection
						installed
						last_sync
						last_provider_sync
						Organisation {
							sync_enabled
						}
					}
				}
			`,
			fetchPolicy: "no-cache",
			update(r) {
				this.loading = false;
				return _.map(r.SchoolsForOrganisation, (school) => {
					school.last_sync = this.convertToLocalTime(school.last_sync);
					school.last_provider_sync = school.Organisation.sync_enabled ? this.convertToLocalTime(school.last_provider_sync) : null;

					return school;
				});
			},
			error(error) {
				this.loading = false;
				this.$message.error("Failed to fetch organisation schools");
				this.hasError = true;
			},
			skip() {
				return this.hasError;
			}
		},
	}
};
</script>
